import { hasRole } from './checkRole'
import { UserRole } from '../types/keycloak'

/**
 * License management UI (sidebar badge, user menu, /license page)
 * requires BOTH:
 * - Keycloak ADMIN role
 * - organization owner (control-plane OwnerAccount linked to the org)
 */
export function canAccessLicenseModule(
  roles: string[] | null | undefined,
  isOwner?: boolean | null
): boolean {
  return hasRole(roles || [], UserRole.ADMIN) && isOwner === true
}
